
let BaseTest = require('@/mixins/Forms/2016/BaseTest')

module.exports = {

    mixins: [BaseTest],

    data() {
        return {
            testResult: 0,
            constructionInspectionResult: 0,
            functionalTestResult: 0,
        }
    },

    methods: {

        resolveTest() {
            setInterval(() => {
                this.evaluateTest();
            }, 500)
        },

        evaluateTest() {
            this.constructionInspection(this.contructionInspectionFrom, this.contructionInspectionTo);
            this.functionalTest(this.functionalTestFrom, this.functionalTestTo);
            this.form.testResult = this.testResult = (this.constructionInspectionResult && this.functionalTestResult) ? 1 : 0;
        },

        functionalTest(from, to) {
            for (var i = from; i <= to; i++) {
                if (!this.isSelected(i)) {
                    this.functionalTestResult = 0;
                    return;
                }
            }
            this.functionalTestResult = 1;
        },

        constructionInspection(from, to) {
            for (var i = from; i <= to; i++) {
                if (!this.isSelected(i)) {
                    this.constructionInspectionResult = 0;
                    return;
                }
            }
            this.constructionInspectionResult = 1;
        },

        isSelected(questionNumber) {
            return $("input[name=att_question_" + questionNumber + "]:checked").val() == 1;
        }
    },
}
